import Vue from 'vue'
import Vuex from 'vuex'

import {getField, updateField} from 'vuex-map-fields'

Vue.use(Vuex)
export const store = new Vuex.Store({
    state:{
        //general
        showHeader:true,
        currentNav:'front',
        username:'',
        password:null,
        oldpassword:'',
        loggedInUser:{
            id:0,
            name:'',
        },
        securityAppName:'BadgeValidation',
        securityAppItems:[],
        loggedIn:false,
        responseMessage:null,

        badgeData:{},
        batchSize:25,
        logoOverride:''
    },
    mutations:{
        updateField,
    },
    getters:{
        getField,
    },
    actions:{

    }
})